function ClaimModel(params, asWorker, $filter) {
    if (!params) params = {};
    var model = {};
    
    model.ClaimId = params.ClaimId || 'null';
    model.ClaimNumber = params.ClaimNumber || 'N/A';
    model.BusinessUnit = params.Scheme;
    model.Scheme = params.Scheme;
    model.PolicyId = params.PolicyId || params.EmployerId;
    model.PolicyNumber = params.PolicyNumber || 'N/A';
    model.EmployerName = params.EmployerName || 'N/A';
    model.WorkerName = params.FullName || params.WorkerName || 'N/A';
    model.InjuryDate = !!$filter ? $filter('EMdate')(params.InjuryDate) : params.InjuryDate;
    model.InjuryNature = params.InjuryNature  || 'N/A';
    model.id = model.ClaimId;
    model.ClientName = params.ClientName;
    model.text = !params.ClaimId ?
        'Select a claim' :
        (!!asWorker ?
            model.ClaimNumber + ' - ' + _.trunc(model.InjuryNature, 30) + ' (' + model.InjuryDate + ')' :
            model.ClaimNumber + ' - ' + model.WorkerName);

    return model;
}